import { Accordion, Button, Badge } from "react-bootstrap";
import { FiClock, FiAward, FiRefreshCw } from "react-icons/fi";

const PlanCard = ({
  plan,
  selectedPlan,
  expandedPlan,
  setSelectedPlan,
  setExpandedPlan,
  userDetails,
  onProceed,
}) => {
  const isFree = plan.is_free_plan;
  const hasDiscount = plan.discount_percentage > 0;
  const gstIncluded = plan.gst_included;
  const isSelected = selectedPlan === plan.id;

  const eventKey = String(plan.id);

  const handleSelect = () => {
    setSelectedPlan(plan.id);
    setExpandedPlan(expandedPlan === plan.id ? null : plan.id);
  };

  const handleProceed = (e) => {
    e.stopPropagation();
    onProceed(plan);
  };

  return (
    <Accordion.Item
      eventKey={eventKey}
      onClick={handleSelect}
      className={`mb-3 shadow-sm rounded border 
        ${isSelected ? "border-primary border-2" : ""}`}
      style={{ cursor: "pointer" }}
    >
      {/* HEADER */}
      <Accordion.Header>
        <div className="w-100 d-flex justify-content-between align-items-center">

          {/* LEFT */}
          <div className="d-flex flex-column">
            <strong className="fs-6">
              {plan.service?.name} – {plan.plan_name}
            </strong>

            <small className="text-muted">{plan.plan_description}</small>

            <div className="mt-1 d-flex gap-2">
              {isFree && <Badge bg="success">Free Trial</Badge>}

              {!isFree && plan.duration_days >= 180 && (
                <Badge bg="warning" text="dark">Best Value</Badge>
              )}

              {hasDiscount && (
                <Badge bg="danger">{plan.discount_percentage}% OFF</Badge>
              )}

            </div>
          </div>

          {/* RIGHT PRICE */}
          <div className="text-end">
            <div className="fs-5 fw-bold">
              {/* {isFree ? "FREE" : `₹${plan.price_paise}`} */}
              {isFree ? "FREE" : `₹${plan.price_paise / 100}`}
            </div>
            <small className="text-muted d-block"> {gstIncluded ? "Inclusive of GST" : "+ GST Applicable"} </small>
            <small className="text-muted d-block">
              {plan.duration_days} days
            </small>
          </div>

        </div>
      </Accordion.Header>

      {/* BODY */}
      <Accordion.Body>

        {plan.offer_text && (
          <div className="alert alert-info py-2 small mb-3">
            {plan.offer_text}
          </div>
        )}

        {/* BENEFITS */}
        <div className="small mb-3">

          <div className="d-flex align-items-center mb-2">
            <FiClock className="me-2 text-primary" />
            <span>Validity: <strong>{plan.duration_days} days</strong></span>
          </div>

          <div className="d-flex align-items-center mb-2">
            <FiAward className="me-2 text-warning" />
            <span>Service: <strong>{plan.service?.name}</strong></span>
          </div>

          {!isFree && (
            <div className="d-flex align-items-center mb-2">
              <FiRefreshCw className="me-2 text-info" />
              <span>
                Auto-Renewal:{" "}
                <strong>{plan.auto_renew ? "Enabled" : "Disabled"}</strong>
              </span>
            </div>
          )}
        </div>

        {/* CTA BUTTON */}
        <Button
          className="w-100 py-2"
          variant={isSelected ? "primary" : "outline-primary"}
          disabled={isFree && userDetails?.has_used_trial}
          onClick={handleProceed}
        >
          {isFree && userDetails?.has_used_trial
            ? "Free Trial Already Used"
            : isSelected
              ? isFree
                ? "Activate Free Trial"
                : "Proceed to Payment"
              : "Choose Plan"}
        </Button>

      </Accordion.Body>
    </Accordion.Item>
  );
};

export default PlanCard;
